"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyWidget = void 0;
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const uppercase_string_1 = require("shared/util/uppercase-string");
// import { UsersIcon } from '../../../../../../components/icons';
const store_1 = require("../../../../../providers/store");
const store_2 = require("../../../../../users/store");
require("./pharmacy-widget.less");
let PharmacyWidget = class PharmacyWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.pharmacy = {};
        this.pharmacyLoaded = false;
        this.provider = {};
        this.providerLoaded = false;
        this.renderProviderInfo = () => {
            if (this.provider && this.provider.value) {
                const { firstName, lastName, npiNumber, title } = this.provider.value;
                const providerName = `${firstName} ${lastName}`;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "pharmacy-widget__provider-title" },
                        React.createElement("h4", null, "Physician in charge:"),
                        " ",
                        `${capitalize_string_1.capitalizeString(providerName)}, ${uppercase_string_1.uppercaseString(title)}`),
                    React.createElement("div", { className: "pharmacy-widget__provider-digit" },
                        React.createElement("h4", null, "Physician NPI number:"),
                        " ",
                        npiNumber)));
            }
            return React.createElement(material_ui_1.Typography, null, "No Provider Found");
        };
    }
    /**
     * Load pharmacy and provider associated with user logged in from store before rendering
     * the the interface.
     */
    async componentWillMount() {
        this.pharmacyLoaded = false;
        this.providerLoaded = false;
        await store_2.usersStore.loadUser();
        this.pharmacy = store_2.usersStore.user.value.site || {};
        this.pharmacyLoaded = true;
        if (this.pharmacy.picProviderId) {
            await store_1.providersStore.readProvider(this.pharmacy.picProviderId);
            this.provider = store_1.providersStore.provider;
            this.providerLoaded = true;
        }
    }
    /**
     * Renders the pharmacy widget, populating the data based on user logged in.
     */
    render() {
        /**
         * For loading gif
         */
        if (!this.pharmacyLoaded) {
            return React.createElement("div", null);
        }
        if (this.pharmacy) {
            const { name, displayName, npiNumber, ncpdpId, deaLicense } = this.pharmacy;
            return (React.createElement("div", { className: "pharmacy-widget widget" }, store_2.usersStore.permissions.ReadPharmacy ? (React.createElement("div", { className: "pharmacy-widget__pharmacy" },
                React.createElement("div", { className: "pharmacy-widget__pharmacy--name" },
                    React.createElement("h4", null, "Pharmacy:"),
                    " ",
                    React.createElement("abbr", { title: capitalize_string_1.capitalizeString(name) }, capitalize_string_1.capitalizeString(displayName))),
                React.createElement("div", { className: "pharmacy-widget__pharmacy--npi" },
                    React.createElement("h4", null, "NPI:"),
                    " ",
                    npiNumber),
                React.createElement("div", { className: "pharmacy-widget__pharmacy--ncpdpid" },
                    React.createElement("h4", null, "NCPDPID:"),
                    " ",
                    ncpdpId),
                React.createElement("div", { className: "pharmacy-widget__pharmacy--dea" },
                    React.createElement("h4", null, "DEA License:"),
                    " ",
                    deaLicense),
                this.providerLoaded && this.renderProviderInfo())) : (store_2.usersStore.showLock())));
        }
        else {
            return (React.createElement("div", { className: "pharmacy-widget widget" },
                React.createElement("h4", { className: "widget__header" }, "Pharmacy Info"),
                "No information to display."));
        }
    }
};
__decorate([
    mobx_1.observable
], PharmacyWidget.prototype, "pharmacy", void 0);
__decorate([
    mobx_1.observable
], PharmacyWidget.prototype, "pharmacyLoaded", void 0);
__decorate([
    mobx_1.observable
], PharmacyWidget.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], PharmacyWidget.prototype, "providerLoaded", void 0);
PharmacyWidget = __decorate([
    mobx_react_1.observer
], PharmacyWidget);
exports.PharmacyWidget = PharmacyWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/pharmacy-widget/pharmacy-widget.tsx
// module id = 3368
// module chunks = 0